var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.567 5.10935C12.225 4.93644 11.8213 4.97043 11.5132 5.19825L6.75368 8.71385H3.61437C2.72414 8.71385 2 9.43913 2 10.3308V14.6694C2 15.561 2.72414 16.2863 3.61437 16.2863H6.75368L11.5132 19.8019C11.6908 19.9333 11.9003 20 12.1111 20C12.2661 20 12.4221 19.964 12.5666 19.8905C12.9083 19.7176 13.1207 19.3721 13.1207 18.9884V6.01113C13.1207 5.62773 12.9083 5.28192 12.5666 5.10902L12.567 5.10935ZM3.00902 14.6694V10.3308C3.00902 9.99642 3.28053 9.72447 3.61437 9.72447H6.41527V15.2757H3.61437C3.28053 15.2757 3.00902 15.0038 3.00902 14.6694ZM12.1121 18.9884L7.4243 15.5257V9.47443L12.1124 6.01145V18.9887L12.1121 18.9884Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9084 9.72073C14.6745 9.56939 14.3622 9.63672 14.2111 9.87108C14.06 10.1054 14.1272 10.4182 14.3612 10.5696C15.0187 10.9948 15.4113 11.7165 15.4113 12.4996C15.4113 13.2827 15.0187 14.0041 14.3612 14.4297C14.1272 14.581 14.06 14.8938 14.2111 15.1281C14.3077 15.2778 14.4699 15.3592 14.6353 15.3592C14.729 15.3592 14.8239 15.3331 14.9084 15.2785C15.8548 14.666 16.42 13.6272 16.42 12.4996C16.42 11.372 15.8551 10.3329 14.9084 9.72073Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4263 7.3655C16.1923 7.21384 15.88 7.28117 15.7289 7.51552C15.5775 7.74988 15.6447 8.06267 15.8787 8.214C17.338 9.15893 18.2093 10.7612 18.2093 12.4997C18.2093 14.2382 17.338 15.8404 15.8787 16.7853C15.6447 16.9367 15.5775 17.2495 15.7289 17.4838C15.8255 17.6335 15.9874 17.7149 16.1531 17.7149C16.2468 17.7149 16.3417 17.6887 16.4266 17.6338C18.1748 16.502 19.2184 14.5827 19.2184 12.4997C19.2184 10.4166 18.1748 8.49738 16.4266 7.3655H16.4263Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMedium);
export default __webpack_public_path__ + "static/media/Volume-Medium.5aa2bdca9a2d6d0cac1fe37fa20d3a41.svg";
export { ForwardRef as ReactComponent };